import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch } from 'vue';
import { IonApp, IonRouterOutlet } from '@ionic/vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { pingGenerator } from '@/services/generatorApi';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();
const router = useRouter();

// Pre-calienta la Cloud Function para evitar el cold start cuando el usuario
// llega al generador. Fire-and-forget: no bloqueamos el render de la app.
pingGenerator();

watch(
  () => store.state.kickedOut,
  (kicked) => {
    if (kicked) {
      router.replace('/login');
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonApp), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonRouterOutlet))
    ]),
    _: 1
  }))
}
}

})